<template>
  <div class="balance-detail">
    <div class="txt1">待结算金额(元)</div>
    <div class="txt2">450.00</div>
    <div class="details-con">
      <div class="con-item">
        <div class="label">当前状态</div>
        <div class="val">待结算</div>
      </div>
      <div class="con-item">
        <div class="label">购买详情</div>
        <div class="val">华琴南 定制喜酱酒x30瓶</div>
      </div>
      <div class="con-item">
        <div class="label">交易时间</div>
        <div class="val">2023-07-16 10:35:35</div>
      </div>
      <div class="con-item">
        <div class="label">到账渠道</div>
        <div class="val">账户余额｜待结算</div>
      </div>
      <div class="con-item">
        <div class="label">交易单号</div>
        <div class="val">385829909871053525546</div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'balance-detail',
  data() {
    return {
      details: {}
    }
  },
  mounted() {
    this.details = JSON.parse(this.$route.query.item)
    console.log(this.details)
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.balance-detail {
  background-color: #1E2020;
  min-height: 100vh;
  padding: 40px 20px;
  box-sizing: border-box;
  .txt1 {
    font-size: 14px;
    color: #999999;
    text-align: center;
    line-height: 14px;
    margin-bottom: 20px;
  }
  .txt2 {
    font-size: 36px;
    color: #FFFFFF;
    font-weight: 600;
    line-height: 36px;
    text-align: center;
    padding-bottom: 36px;
    border-bottom: 1px solid #666666;
  }
  .details-con {
    padding-top: 20px;
    box-sizing: border-box;
    .con-item {
      display: flex;
      align-items: center;
      line-height: 30px;
      .label {
        font-size: 14px;
        color: #939399;
        margin-right: 20px;
      }
      .val {
        color: #FFFFFF;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/balanceDetail.vue